import { useState } from "react";
import { Modal } from "react-bootstrap";
import CustomFilter from "./CustomFilter";
import { usePostApiRequest } from "../../../helpers/api";
import Cookies from "js-cookie";
import LoadingSpinner from "../../loading/LoadingSpinner";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;

const FilterModal = ({
  show,
  onHide,
  customFilterData,
  setCustomFilterData,
  getProducts,
  setProductData,
  setPageOffSet,
  setSendCustomData,
  stockData,
}) => {
  const [isLoadingApi, setIsLoadingApi] = useState(false);
  const postApiRequest = usePostApiRequest();

  const onCloseModal = () => {
    onHide();
  };

  const saveStock = async () => {
    const formattedData = customFilterData.map(
      ({ Id, Weight, Pcs, Size, SizeCode, ...rest }) => {
        const newObj = {
          ...rest,
          Size,
          SizeCode,
          CaratWeight: Weight,
          NumberOfPCS: Pcs,
          Id,
        };
        return Id === 0 ? newObj : { Id, ...newObj };
      }
    );

    try {
      await postApiRequest({
        url: "/Customer/SaveCustomerStock",
        method: "POST",
        data: formattedData,
        queryKey: ["customerStock"],
        noToast: true,
      });
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const filterProducts = () => {
    setSendCustomData(true);
    setProductData([]);
    setPageOffSet(1);
    getProducts(null, true);
    saveStock();
  };

  const clearCustomFilter = async () => {
    setIsLoadingApi(true);
    try {
      const response = await postApiRequest({
        url: "/Customer/DeleteCustomerStock",
        method: "POST",
        data: { CustomerId: Number(customerId) },
        queryKey: ["customerStock"],
        noToast: true,
      });

      if (response.Status === true) {
        setCustomFilterData([
          {
            Id: 0,
            Shape: "ROUND",
            Size: "",
            Weight: "",
            Pcs: "",
            SizeCode: "",
            CustomerId: Number(customerId),
          },
        ]);
        setProductData([]);
        setPageOffSet(1);
        setSendCustomData(false);
        getProducts(null, false);
      }
    } catch (error) {
      console.error("API call failed:", error);
      return;
    } finally {
      setIsLoadingApi(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="filter_modal"
      backdrop="static"
      keyboard={false}
    >
      {isLoadingApi && <LoadingSpinner />}
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ fontSize: "15px" }}
        >
          Filter With My Diamonds
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* custom filters */}
        <CustomFilter
          customFilterData={customFilterData}
          setCustomFilterData={setCustomFilterData}
          customerId={customerId}
          stockData={stockData}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className="close_btn" onClick={clearCustomFilter} type="button">
          Clear All
        </button>
        <button className="submit_btn" onClick={filterProducts} type="button">
          Apply Filters
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;
